import { useQuery } from '@tanstack/react-query'

import { ownerApi } from '../ownerApi.js'

// Mirrors the API's TenantAnalyticsResponse (services/admin/analytics.ts) —
// the owner endpoint returns the same shape, scoped to the session's tenant.
export interface AnalyticsDailyRow {
  date: string
  passes_installed: number
  stamps_issued: number
  rewards_redeemed: number
  milestones_earned: number
  cycle_completions: number
  broadcasts_sent: number
  active_customers: number
}

export type AnalyticsMetric = keyof Omit<AnalyticsDailyRow, 'date'>

export interface ReturnVisitStats {
  returning_customers: number
  total_customers: number
  /** null when nobody stamped in range — distinct from "0% returning". */
  rate: number | null
}

export interface OwnerAnalyticsResponse {
  from: string
  to: string
  daily: AnalyticsDailyRow[]
  totals: Omit<AnalyticsDailyRow, 'date'>
  previous_totals: Omit<AnalyticsDailyRow, 'date'>
  last_activity: {
    last_stamp_at: string | null
    last_broadcast_at: string | null
  }
  last_refreshed_at: string | null
  return_visit: ReturnVisitStats
}

export function useOwnerAnalytics(from: string, to: string) {
  return useQuery({
    queryKey: ['owner', 'analytics', from, to],
    queryFn: () =>
      ownerApi.get<OwnerAnalyticsResponse>(
        `/owner/analytics?from=${from}&to=${to}`,
      ),
    enabled: Boolean(from && to),
    staleTime: 60_000,
  })
}
